import classNames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';
import { getImageAtSize } from '../../lib/utils';

import { useThemeClassName } from '../../contexts/ThemeContext';
import StyledButton from '../buttons/StyledButton';
import HelpModal from '../modals/HelpModal';
import Body from '../partials/Body';

import styles from '../../../styles/popups/default-popup.module.scss';

const propTypes = {
    image: AppPropTypes.image,
    title: PropTypes.string,
    description: PropTypes.string,
    onClose: PropTypes.func,
    className: PropTypes.string,
};

const defaultProps = {
    image: null,
    title: null,
    description: null,
    onClose: null,
    className: null,
};

function DefaultPopup({ image, title, description, onClose, className }) {
    const themeClassName = useThemeClassName(styles);
    const { url: imageUrl = null } = getImageAtSize(image) || {};

    return (
        <HelpModal
            onClose={onClose}
            withCloseButton={false}
            contentClassName={styles.helpContent}
            closeButtonClassName={styles.modalCloseButton}
        >
            <div className={classNames([styles.container, themeClassName, className])}>
                {title !== null ? <Body className={styles.title} body={title} /> : null}
                {imageUrl !== null ? (
                    <div className={styles.imageContainer}>
                        <img src={imageUrl} className={styles.image} alt="Splash" />
                    </div>
                ) : null}
                {description !== null ? (
                    <Body className={styles.description} body={description} />
                ) : null}
                {onClose !== null ? (
                    <StyledButton onClick={onClose} className={styles.closeButton}>
                        <FormattedMessage defaultMessage="Close" description="Button label" />
                    </StyledButton>
                ) : null}
            </div>
        </HelpModal>
    );
}

DefaultPopup.propTypes = propTypes;
DefaultPopup.defaultProps = defaultProps;

export default DefaultPopup;
